import Web3 from 'web3';

/**
 * Gets the standard gas price based on network congestion
 * When the network is not busy, the minimum gas price is typically 0.1 gwei
 * @param {Web3} web3 - Web3 instance
 * @param {Object} logger - Optional logger object with addLog method
 * @returns {Promise<BigInt>} Standard gas price in wei
 */
export const getStandardGas = async (web3, logger = null) => {
  if (!web3) {
    throw new Error('Web3 instance is required');
  }

  try {
    // Get current gas price from the network
    const gasPrice = await web3.eth.getGasPrice();
    const gasPriceBigInt = BigInt(gasPrice);
    
    // Convert to gwei for logging (1 gwei = 10^9 wei)
    const gasPriceGwei = Number(gasPriceBigInt) / 1e9;
    
    // Minimum gas price: 0.1 gwei (in wei)
    const MIN_GAS_PRICE = BigInt(100000000); // 0.1 gwei in wei
    
    // Ensure gas price is at least the minimum
    const standardGas = gasPriceBigInt < MIN_GAS_PRICE ? MIN_GAS_PRICE : gasPriceBigInt;
    
    const logMessage = `当前Gas价格: ${gasPriceGwei.toFixed(2)} gwei, 使用的标准Gas: ${Number(standardGas) / 1e9} gwei`;
    
    if (logger) {
      logger.addLog(logMessage);
    } else {
      console.log(logMessage);
    }
    
    return standardGas;
  } catch (error) {
    const errorMessage = `获取Gas价格失败: ${error.message}`;
    
    if (logger) {
      logger.addLog(errorMessage);
    } else {
      console.error(errorMessage);
    }
    
    // Fallback to minimum gas price if there's an error
    return BigInt(100000000); // 0.1 gwei in wei
  }
};

export default getStandardGas; 